import { type ActionDispatch, type Reducer, type ReducerState, type RefObject, useReducer, useRef } from 'react';

export const useRefReducer = <S, A>(
  reducer: Reducer<S, A>,
  initialState: S
): [RefObject<ReducerState<(s: S, a: A) => S>>, ActionDispatch<[A]>] => {
  const ref = useRef(initialState);
  return [ref, useReducer((state: S, action: A) => (ref.current = reducer(state, action)), initialState)[1]];
};
